import {Suspense, useState} from "react";
import materialDefault from "images/ic_material.png";
import styles from "./index.module.scss";
import PropertyLibrary from "components/PropertyLibrary";
import Spinner from "components/Layout/components/ObjectPanel/fallbacks/Spinner";

const ParticleTextureInput = ({name, propertyName, inputOnChange, thumbnail}) => {
  const [isParticleLibraryOpened, setIsParticleLibraryOpened] = useState(false);
  const handleParticleLibrary = () => {
    if (propertyName === "particleTexture") {
      setIsParticleLibraryOpened(!isParticleLibraryOpened);
    }
  };
  let title = name;
  if (name === "Particle Texture") title = "Texture";

  return (
    <div className={styles.container}>
      <p className={styles.title}>{title}</p>
      <label className={styles.input_wrapper}>
        <input
          className={styles.input_file}
          type="file"
          onChange={e => {
            const imgUrl = window.URL.createObjectURL(e.target.files[0]);
            inputOnChange(name, imgUrl, e);   // previously: inputOnChange(name, imgUrl)
          }}
        ></input>
      </label>
      <img className={styles.texture_box} src={thumbnail ? thumbnail : materialDefault} alt="material" onClick={handleParticleLibrary} />
      {isParticleLibraryOpened && (
        <Suspense fallback={<Spinner />}>
          <PropertyLibrary name={name} propertyName={propertyName} onClickItem={inputOnChange} onClickClose={handleParticleLibrary} />
        </Suspense>
      )}
    </div>
  );
};

export default ParticleTextureInput;
